import { useTranslation } from "react-i18next";
import { formatCount } from "@/lib/format-number";

export function BrandVolumeCaption({ count }: { count: number | null | undefined }) {
  const { t } = useTranslation();
  if (count == null) return null;
  return (
    <span className="shrink-0 text-xs text-muted-foreground">
      {t("dashboard.globalFilterHeader.assetCountCreatives", {
        count,
        formattedCount: formatCount(count),
        defaultValue_one: "{{formattedCount}} creative",
        defaultValue_other: "{{formattedCount}} creatives",
      })}
    </span>
  );
}
